import mitt from 'mitt'
const events = mitt()
export default events
